<template>
  <div class="cottonBot-manage">
    <template v-for="(item, index) in config" :key="index">
      <template v-if="index === 0 || (index === 1 && config[0].isopen )">
        <div class="cottonBot-manage-title">
          <span>{{ item.title }}</span>
          <span style="color: #5D6F8E;margin-right: 5px;" v-if="item.isopen !== undefined">
            单独设置我的对话习惯
            <el-switch v-model="item.isopen" @change="aloneTalkChange"></el-switch>
            <el-icon class="del-icon" v-show="isSelf" @click="delBot"><Delete /></el-icon>
          </span>
        </div>
        <div class="cottonBot-manage-input">
          <el-input
            v-model="item.value"
            :autosize="{ minRows: 10, maxRows: 10 }"
            :placeholder="item.placeholder"
            :disabled="index === 0"
            type="textarea"
          />
        </div>
      </template>
    </template>
    <div class="sub-btn"><el-button type="primary" @click="submit">确认保存</el-button></div>
  </div>
</template>

<script setup>
  import { ref, defineProps, defineEmits, watch, onBeforeUnmount } from 'vue'
  import { cloneDeep } from 'lodash'
  import { addaiusermodel, getaiusermodellist, deleteaiusermodel, updateaiusermodel } from '@/port/clientSide/cottonBot.js'
  const props = defineProps({
    botConfig: {
      type: Object,
      default: () => { return {} }
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    robotId: {
      type: Number,
      default: 0
    }
  })
  const botInfo = ref(null)
  const config = ref([
    { title: 'Ai智能体描述', isopen: false, value: '', placeholder: '' },
    { title: '我的个性化要求', value: '', placeholder: '个人对智能体个性化要求可以在此进行说明' }
  ])

  const emit = defineEmits(['delBot', 'confirm'])

  const delBot = async () => {
    if (userTalkId.value) {
      await deleteaiusermodel({ aiUsermodelId: userTalkId.value })
    }
    emit('delBot', props.botConfig)
  }

  const userTalkId = ref(null)
  const getUserTalk = async () => {
    const query = {
      aiRobotIds: props.robotId,
      aiModelIds: botInfo.value.aiModelId,
      curpage: 0,
      pagesize: 0,
    }
    const { code, data } = await getaiusermodellist(query)
    if (code === 0 && data.length > 0) {
      const val = data[0]
      const { isAloneTalk, aloneTalkContent } = JSON.parse(val.config)
      config.value[0].isopen = isAloneTalk || false
      config.value[1].value = aloneTalkContent || ''
      userTalkId.value = val.aiUsermodelId
    } else {
      config.value[0].isopen = false
      config.value[1].value = ''
    }
  }

  const aloneTalkChange = (val) => {
    if (!val) {
      config.value[1].value = ''
    }
  }

  const submit = async () => {
    const obj = {
      isAloneTalk: config.value[0].isopen,
      aloneTalkContent: config.value[1].value
    }
    let fn = addaiusermodel
    let query = { aiRobotId: props.robotId, aiModelId: botInfo.value.aiModelId, config: obj }
    let msg = '新增成功'
    if (userTalkId.value) {
      // 修改
      query = { aiUsermodelId: userTalkId.value, config: obj }
      fn = updateaiusermodel
      msg = '修改成功'
    }
    await fn(query)
    promptMessage(msg)
  }

  import { ElMessage } from 'element-plus'
  const promptMessage = (message = '', type = 'success') => {
    ElMessage({
      type,
      message,
    })
  }
  watch(
    () => props.botConfig,
    (newVal) => {
      if (newVal) {
        botInfo.value = cloneDeep(newVal)
        userTalkId.value = null
        config.value[0].value = newVal.description
        getUserTalk()
      }
    },
    { 
      deep: true, // 深度监听
      immediate: true // 立即执行一次
    }
  )
  onBeforeUnmount(() => {
    console.log('bot管理关闭了')
  })
</script>

<style lang="scss" scoped>
  .cottonBot-manage {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    &-title {
      padding: 20px 0 10px 0;
      display: flex;
      justify-content: space-between;
      line-height: 32px;
      .del-icon {
        cursor: pointer;
        color: red;
        font-size: 20px;
        margin-left: 4px;
        position: relative;
        top: 5px;
      }
    }
    :deep(.el-textarea__inner) {
      background-color: #F2F7FF;
      box-shadow: none;
    }
    .sub-btn {
      text-align: right;
      margin-top: 40px;
    }
    :deep(.el-button) {
      background: linear-gradient(46.68deg, rgba(37, 170, 246, 1) 0%, rgba(39, 145, 245, 1) 24.94%, rgba(111, 105, 255, 1) 77.88%, rgba(166, 107, 255, 1) 100%);
      border-radius: 27px;
    }
  }
</style>